import { Injectable, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';

import { PromptComponent } from '../components/prompt/prompt.component';

export interface PromptOptions {
  title?: string;
  message?: string;
  acceptText?: string;
  cancelText?: string;
  initialValue?: string; // Add initialValue property
}

@Injectable({
  providedIn: 'root',
})
export class PromptService {
  private readonly dialogService = inject(DialogService);

  /**
   * Opens a prompt dialog.
   * @param options Configuration options for the prompt dialog.
   * @returns A promise that resolves with the input value if accepted, or null if canceled.
   */
  openPrompt(options: PromptOptions): Promise<string | null> {
    const dialogRef = this.dialogService.open(PromptComponent, {
      data: {
        title: options.title || 'Prompt',
        message: options.message || '',
        acceptText: options.acceptText || 'Accept',
        cancelText: options.cancelText || 'Cancel',
        initialValue: options.initialValue || '', // Pass initialValue to component data
      },
      header: options.title || 'Prompt', // Set header for accessibility and title bar
      closable: true,
      modal: true,
      width: '700px', // Optional: Adjust width as needed
    });

    // Return the result when the dialog closes
    return firstValueFrom(dialogRef.onClose);
  }
}
